import { cx } from "@light-technology/components";
import type { ReactNode } from "react";
import { ChartErrorIcon } from "./ChartErrorIcon";

type ChartCardProps = {
  title: string;
  hasError?: boolean;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  isFullHeightChart?: boolean;
};

export function ChartCard({
  title,
  hasError = false,
  action,
  children,
  className,
  isFullHeightChart,
}: ChartCardProps) {
  return (
    <div
      className={cx(
        "rounded-xl border border-secondary",
        "relative flex flex-col overflow-hidden pt-3xl",
        isFullHeightChart && "min-h-80",
        className,
      )}
    >
      <div
        className={cx(
          "z-1 flex items-center gap-sm px-3xl",
          action && "justify-between",
        )}
      >
        <div className="flex items-center gap-sm">
          <h3 className="text-lg font-semibold">{title}</h3>
          <ChartErrorIcon show={hasError} />
        </div>
        {action}
      </div>
      {isFullHeightChart ? (
        <div className="absolute top-0 right-0 bottom-0 left-0 flex h-full w-full">
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
